import React from 'react'
import Quiz from '../../components/Quiz/Quiz'

function QuizPage() {
  return (
    <Quiz />
  )
}

export default QuizPage